import React from "react";
import { connect } from "react-redux";
import { AppState, store } from "../../../redux";
import { setAuthState } from "../../../redux/actions";
import { AUTHENTICATION_MODAL_ID, AUTH_SIGNUP } from "../../../redux/authentication/constants";
import headerImage from "../images/heroImage.jpg";

import RadivisionLogo from "../../../../static/get-started-logo.png";

const header = () => {
  return (
    <div className="getting-started-banner" style={{ backgroundImage: `url(${headerImage})` }}>
      {/* <div className="banner-shade" /> */}
      <div className="banner-content">
        <img className="banner-logo" src={RadivisionLogo} />

        <div className="gs-btn">
          <a
            href="#"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target={`#${AUTHENTICATION_MODAL_ID}`}
            onClick={(e) => {
              e.preventDefault();
              store.dispatch(setAuthState({ step: AUTH_SIGNUP }));
            }}
          >
            Join
          </a>
        </div>
        <div className="banner-text">The Entrepreneurial Revolution</div>
      </div>
    </div>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const Header = connect(mapState, mapDispatch)(header);
